import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import type { BusinessLogger, TpaHandlerProvider, WixBiSession } from '@wix/thunderbolt-symbols'
import {
	BusinessLoggerSymbol,
	CurrentRouteInfoSymbol,
	SiteFeatureConfigSymbol,
	WixBiSessionSymbol,
} from '@wix/thunderbolt-symbols'
import type { TpaCommonsSiteConfig } from 'feature-tpa-commons'
import { name as tpaCommonsName } from 'feature-tpa-commons'
import { runtimeTpaCompIdBuilder } from '@wix/thunderbolt-commons'
import type { ICurrentRouteInfo, IPageNumber } from 'feature-router'
import { PageNumberSymbol } from 'feature-router'

export type MessageData = {}
export type HandlerResponse = void

export const ApplicationLoadedHandler = withDependencies(
	[
		named(SiteFeatureConfigSymbol, tpaCommonsName),
		WixBiSessionSymbol,
		CurrentRouteInfoSymbol,
		optional(PageNumberSymbol),
		optional(BusinessLoggerSymbol),
	],
	(
		{ debug }: TpaCommonsSiteConfig,
		wixBiSession: WixBiSession,
		currentRouteInfo: ICurrentRouteInfo,
		pageNumberHandler?: IPageNumber,
		businessLogger?: BusinessLogger
	): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				applicationLoaded(compId, _msgData, { appDefinitionId, tpaCompData: { widgetId } = {} }): HandlerResponse {
					if (runtimeTpaCompIdBuilder.isRuntimeCompId(compId)) {
						if (debug) {
							console.warn(`applicationLoaded is ignored in runtime component ${compId}`)
						}
						return
					}

					const routeInfo = currentRouteInfo.getCurrentRouteInfo()
					const tts = Math.round(performance.now())
					businessLogger?.logger.log(
						{
							appId: appDefinitionId,
							widget_id: widgetId,
							instance_id: compId,
							src: 42,
							// APP_LOADED_SUCCESSFULLY
							evid: 643,
							tts,
							pid: routeInfo ? routeInfo.pageId : null,
							pn: pageNumberHandler!.getPageNumber(),
						},
						{ endpoint: 'ugc-viewer' }
					)
				},
			}
		},
	})
)
